var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThermometer = function SvgIconThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.18 3.305a2.75 2.75 0 0 1 4.695 1.945v9.263a1 1 0 0 0 .23.639 3.875 3.875 0 1 1-5.96 0 1 1 0 0 0 .23-.64V5.25c0-.73.29-1.429.805-1.945M10.125.5a4.75 4.75 0 0 0-4.75 4.75v8.92a5.875 5.875 0 1 0 9.5 0V5.25A4.75 4.75 0 0 0 10.125.5m9.25 7a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0m.875-2.875a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0-5.75m-10.25 13a.125.125 0 1 1 .25 0 .125.125 0 0 1-.25 0m-.875-9v7.124a2.125 2.125 0 1 0 2 0V8.625a1 1 0 1 0-2 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconThermometer;